module.exports = __webpack_public_path__ + "static/media/service_icon_01.1e771d05.webp";